import { css } from "@emotion/react";
import styled from "@emotion/styled";
import { Color, Colors } from "../../../globalTypes/theme";

export const styledNotificationLinkCss = (
  notificationCount: number,
  colors: Colors,
  backgroundColor?: Color
) =>
  css`
    display: ${!notificationCount ? "none" : "flex"};
    overflow: hidden;
    justify-content: center;
    align-items: center;
    border-radius: 12.5px;
    height: 25px;
    min-width: 25px;

    border: none;

    padding: 0 5px;
    ${notificationCount > 999 && "padding-left: 6px"};

    font-size: 14px;
    font-weight: bold;

    color: white;
    background-color: ${backgroundColor ?? colors.delete};

    &:hover {
      text-decoration: none;
      color: white;
    }
  `;

export const StyledLink = styled("button", {
  shouldForwardProp: (prop) =>
    prop !== "notificationCount" && prop !== "backgroundColor",
})<{
  notificationCount: number;
  backgroundColor?: Color;
}>`
  ${({ theme, notificationCount, backgroundColor }) =>
    styledNotificationLinkCss(notificationCount, theme.colors, backgroundColor)}
`;
